/** AssigneeChipPicker.tsx — 담당자 칩 (복수 선택 가능) */
import { C, T, R } from './ui';

export interface Staff {
  id: string;
  name: string;
  username?: string;
}

interface Props {
  value: string[];
  staff: Staff[];
  myId: string;
  onChange: (ids: string[]) => void;
  single?: boolean;
}

export default function AssigneeChipPicker({ value, staff, myId, onChange, single }: Props) {
  const me = staff.find(s => s.id === myId);
  const others = staff.filter(s => s.id !== myId);

  function toggle(id: string) {
    if (single) { onChange([id]); return; }
    const set = new Set(value);
    if (set.has(id)) set.delete(id);
    else set.add(id);
    if (set.size === 0) set.add(myId);
    onChange(Array.from(set));
  }

  function chip(s: Staff, isMe: boolean) {
    const act = value.includes(s.id);
    const label = isMe ? `👤 ${s.name} (나)` : s.name;
    return (
      <button key={s.id} onClick={() => toggle(s.id)}
        style={{
          padding: '5px 12px', borderRadius: R.sm,
          border: act ? `1.5px solid ${C.accent}` : `1px solid ${C.border}`,
          background: act ? C.accentLt : C.white,
          color: act ? C.accent : C.sub,
          fontSize: T.sm, fontWeight: act ? 700 : 500, cursor: 'pointer',
        }}>
        {act && !single ? '✓ ' : ''}{label}
      </button>
    );
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: 'center' }}>
      {me && chip(me, true)}
      {others.map(s => chip(s, false))}
      {!single && value.length > 1 && (
        <span style={{ fontSize: T.xs, color: C.muted, marginLeft: 4 }}>
          ({value.length}명 선택)
        </span>
      )}
    </div>
  );
}
